import { render } from "./HandleCodeView.vue?vue&type=template&id=4bbb0706&ts=true"
import script from "./HandleCodeView.vue?vue&type=script&lang=ts"
export * from "./HandleCodeView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__